(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bridgman-faqs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    $('body').on('click', '.bridgman_faq__question', function () {
      $(this).next('.bridgman_faq__answer').slideToggle(150).toggleClass('active');
      $(this).toggleClass('active');
    });

    $(document).on('shopify:block:select', '#shopify-section-page-bridgman_faq-template', function (event) {
      $(event.target).find('.bridgman_faq__answer').slideDown(150);
    });

    $(document).on('shopify:block:deselect', '#shopify-section-page-bridgman_faq-template', function (event) {
      $(event.target).find('.bridgman_faq__answer').slideUp(150);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bridgman-showrooms"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    jQuery('[data-slider]').each(function () {
      const $root = $(this),
        $track = $root.find('[data-slick]').first(),
        $prev = $root.find('[data-slider-prev]').first(),
        $next = $root.find('[data-slider-next]').first();

      $track.slick({
        slidesToShow: Number($track.data('slides-to-show')) || 1,
        slidesToScroll: Number($track.data('slides-to-scroll')) || 1,
        speed: Number($track.data('speed')) || 300,
        infinite: String($track.data('infinite')) === 'true',
        arrows: String($track.data('arrows')) !== 'false',
        prevArrow: $prev,
        nextArrow: $next,
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read base URL from data attribute
  var baseUrl = productRecommendationsSection.dataset.baseUrl;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};

// Listen for changes done in the Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
